{
  "en": {
    "space": {
      "actions": {
        "assignOtherUnit": "Reassign to Unit",
        "assignSpace": "Assign Space",
        "assignUnit": "Assign to a unit",
        "cancel": "Undo",
        "closeEdit": "Close Edit",
        "create_space": "Create space",
        "delete": "Remove",
        "edit": "Edit",
        "goToSpaces": "Create new spaces",
        "new": "Space",
        "save": "Save",
        "unassign": "Unassign Unit",
        "unassignSpaces": "Unassign Spaces"
      },
      "attributes": {
        "category": "Type",
        "description": "Description",
        "level": "Level",
        "name": "Name",
        "price_value": "Total sales value",
        "price_value_construction": "Construction value",
        "price_value_land": "Land value",
        "quotity": "Transfer amount portion",
        "status": "Status",
        "unit": "Unit"
      },
      "category": {
        "bicyclestorage": "Bicycle Storage",
        "cellar": "Cellar",
        "garagebox": "Garage Box",
        "other": "Other",
        "outdoor_space": "Outdoor Space",
        "parkinglot": "Parking Lot",
        "storage": "General Storage",
        "winecellar": "Wine cellar"
      },
      "labels": {
        "allSpacesAssigned": "All spaces have been assigned to a unit.",
        "assignedSpaces": "Assigned Spaces",
        "internal": "Internal",
        "noCategory": "No Type Defined",
        "noSpaceAssigned": "No spaces assigned",
        "noSpaces": "No Spaces created yet",
        "notAssignedToUnit": "No Unit Assigned",
        "onlyAvailableSpacesShown": "Only available spaces are shown",
        "selectToUnassign": "Select to unassign",
        "space": "Space",
        "spaces": "Spaces",
        "spacesProject": "Spaces in Project {project}",
        "unassignedSpaces": "Unassigned Spaces"
      },
      "validation": {
        "needCategory": "Type is required",
        "needName": "Name required",
        "needNumber": "Must be a Number (e.g. 95)",
        "selectSpace": "Select at least 1 space"
      }
    }
  }
}
